var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBillicons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    style: {
      width: "1em",
      height: "1em",
      verticalAlign: "middle",
      fill: "currentColor",
      overflow: "hidden"
    },
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M365.714286 409.6h297.447619v97.52381H365.714286zM365.714286 565.638095h297.447619v97.52381H365.714286z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.638095 29.257143v424.228571H195.047619v541.257143l195.047619-121.904762 92.647619 73.142857 58.514286-78.019047-146.285714-117.028572L292.571429 819.2V287.695238h448.609523v277.942857h97.52381V453.485714H975.238095V29.257143H53.638095z m819.2 326.704762h-39.009524V190.171429H195.047619v165.790476h-43.885714V126.780952H877.714286v229.180953z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M877.714286 814.32381c14.628571-19.504762 29.257143-48.761905 29.257143-78.019048 0-68.266667-58.514286-126.780952-126.780953-126.780952s-126.780952 58.514286-126.780952 126.780952c0 29.257143 9.752381 58.514286 29.257143 78.019048-53.638095 34.133333-92.647619 92.647619-92.647619 165.790476h78.019047c0-63.390476 53.638095-112.152381 112.152381-112.152381s112.152381 53.638095 112.152381 112.152381h78.019048c0-68.266667-39.009524-131.657143-92.647619-165.790476z m-151.161905-78.019048c0-29.257143 24.380952-48.761905 48.761905-48.761905 29.257143 0 48.761905 24.380952 48.761904 48.761905s-24.380952 48.761905-48.761904 48.761905-48.761905-19.504762-48.761905-48.761905z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillicons);
export default __webpack_public_path__ + "static/media/billicons.ff44d78f.svg";
export { ForwardRef as ReactComponent };